import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ISolicitudEquipoModel } from 'src/app/models/interfaces/solicitud/ISolicitudEquipoModel';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { EquipoModel } from 'src/app/models/solicitud/EquipoModel';
import { SolicitudEquipoDocumentosService } from 'src/app/services/solicitud-equipo-documentos/solicitud-equipo-documentos.service';
import { SolicitudEquipoService } from 'src/app/services/solicitud-equipo/solicitud-equipo.service';
import * as fileSaver from 'file-saver';
import { VisorPdfDialogComponent } from 'src/app/components/shared/visor-pdf-dialog/visor-pdf-dialog.component';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';
import { SolicitudSeccion } from 'src/app/models/common/enumModel';

@Component({
  selector: 'app-equipo-readonly-dialog',
  templateUrl: './equipo-readonly-dialog.component.html',
  styleUrls: ['./equipo-readonly-dialog.component.css']
})
export class EquipoReadonlyDialogComponent implements OnInit {
  model!: ISolicitudEquipoModel;
  displayedColumns: string[] = [
    'nombre',
    'idRequisito',
    'fechaVencimiento',
    'idDocumento'
  ];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EquipoReadonlyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EquipoModel,
    private solicitudEquipoService: SolicitudEquipoService,
    private solicitudEquipoDocumentoService: SolicitudEquipoDocumentosService,
  ) {
    this.model = new EquipoModel();
  }

  ngOnInit(): void {
    this.solicitudEquipoService.getById(this.data.idSolicitud, this.data.idSolicitudEquipo).subscribe(p => {
      // console.log(p);      
      this.model = p;
      this.model.idSolicitud = this.data.idSolicitud;
      this.model.codigoSolicitud = this.data.codigoSolicitud;
      this.model.logs = this.model.logs.filter(p => p.comentarios != "" && p.comentarios != null);
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  downloadDocumentFromService(element: DocumentacionRequeridaModel) {
    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.Equipos;
      modelVisor.idRegistro = this.model.idSolicitudEquipo;
      modelVisor.idSolicitudDocumento = element.idSolicitudEquipoDocumento;
      modelVisor.codigoSolicitud = this.model.codigoSolicitud;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudEquipoDocumentoService.downloadDocumento(
        this.model.codigoSolicitud,
        this.model.idSolicitudEquipo,
        element.idSolicitudEquipoDocumento
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      });
    }
  }
}
